import React, {useState, useEffect} from 'react'
import {Button, Modal, ModalTitle, Spinner} from 'react-bootstrap'

const formatTime = (totalSeconds) => {
    const minutes = Math.floor(totalSeconds / 60)
    const seconds = totalSeconds % 60
    return `${minutes}:${seconds.toString().padStart(2, '0')}`
}

const SessionWarningDialog = ({onExtendClicked, onLogoutClicked, extendingSession, timeoutSeconds = 180}) => {
    const [secondsLeft, setSecondsLeft] = useState(timeoutSeconds)

    // Decrements secondsLeft every second
    useEffect(() => {
        const timer = setInterval(() => {
            setSecondsLeft(prev => prev - 1)
        }, 1000)
        return () => clearInterval(timer)
    }, [])

    useEffect(() => {
        if (secondsLeft <= 0) {
            onLogoutClicked()
        }
    }, [secondsLeft, onLogoutClicked])

    return (
        <Modal
            show={true}
            onHide={onExtendClicked}
            backdrop="static"
            keyboard={false}
            centered
        >
            <Modal.Header>
                <ModalTitle><h3>Sessionen håller på att gå ut</h3></ModalTitle>
            </Modal.Header>
            <Modal.Body>
                <p>Din session avslutas om <strong>{formatTime(secondsLeft)}</strong>.</p>
                <p>Vill du fortsätta vara inloggad?</p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="outline-secondary" onClick={onLogoutClicked} disabled={extendingSession}>Logga ut</Button>
                <Button variant="primary" onClick={onExtendClicked} disabled={extendingSession}>
                    {extendingSession ? <><Spinner size="sm" className="me-1"/> Verifierar...</> : 'Fortsätt'}
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default SessionWarningDialog;
